import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 檢查 單一分公司
 */
const CheckBid = [
    'POST',
    RouteUrlList.API_CheckBid.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: 'OK',
        errorCode: '',
        bid: '8840'
    }
];
export default CheckBid;
